module.exports = __webpack_public_path__ + "49a92fa50c89604876aa32f48a12a4dd.png";